import React from "react";
import { Outlet, Link } from "react-router-dom";
import Navbar from "./Navbar";
import { Youtube, Twitter } from "lucide-react";

function PatreonIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <circle cx="15" cy="8.5" r="6" />
      <rect x="2.5" y="2.5" width="4.5" height="19" />
    </svg>
  );
}

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="app-layout">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <footer className="border-t border-white/5 py-8 bg-black/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-5">
          <div className="text-center text-[11px] uppercase tracking-[0.25em] text-zinc-500 font-bold">
            18 U.S.C. § 2257 —{" "}
            <Link to="/compliance" data-testid="footer-2257" className="text-[#E50914] hover:underline">
              Record-Keeping Requirements Compliance Statement
            </Link>
          </div>
          <p className="text-[11px] text-center text-zinc-500 max-w-3xl mx-auto leading-relaxed">
            All persons depicted in visual content on this site were at least 18 years of age at the
            time such visual depictions were created. This site does not host original explicit
            content — it curates and embeds material from third-party platforms which maintain their
            own 2257 records. For details, see the full{" "}
            <Link to="/compliance" className="text-[#E50914] hover:underline">Compliance Statement</Link>.
            <br />
            <strong className="text-zinc-300">You must be 18+ (or the age of majority in your jurisdiction) to use this site.</strong>
          </p>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-4 border-t border-white/5">
            <div className="text-xs text-zinc-500">
              © {new Date().getFullYear()}{" "}
              <span className="font-display font-black text-white">
                Savage<span className="text-[#E50914]">Boy</span>
              </span>. All rights reserved.
            </div>
            <div className="flex items-center gap-5 text-xs">
              <Link to="/compliance" data-testid="footer-compliance" className="text-zinc-500 hover:text-white">2257 Compliance</Link>
              <Link to="/dmca" data-testid="footer-dmca" className="text-zinc-500 hover:text-white">DMCA</Link>
              <a href="mailto:savageboyuncensored@gmail.com" className="text-zinc-500 hover:text-white">Contact</a>
            </div>
            <div className="flex items-center gap-4 text-zinc-500">
              <a href="https://x.com/SavageMYT" target="_blank" rel="noreferrer" aria-label="X (Twitter)" data-testid="social-twitter" className="hover:text-white transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/@SavageBoyHD" target="_blank" rel="noreferrer" aria-label="YouTube" data-testid="social-youtube" className="hover:text-[#FF0000] transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="https://www.patreon.com/c/SavageUncensored" target="_blank" rel="noreferrer" aria-label="Patreon" data-testid="social-patreon" className="hover:text-[#E50914] transition-colors">
                <PatreonIcon className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
